<a class="ios" target="_blank" [url]="appStoreUrl">
  <img class="apple" src="/assets/appstore/apple/black.svg" />
</a>
<a class="android" target="_blank" [url]="playStoreUrl">
  <img src="/assets/appstore/google/black.png" />
</a>